import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form, Input, Button, Typography, message, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { ROW_JUSTIFY, COL_SPAN, LOCAL_LANG } from '../common/const'
import API from '../config/api'
import { PostEmailInvite } from '../config/request'
import { GetErrMsg } from '../config/errCode'

import { UrlQueryParamsParse } from '../common/globalFun'
import { useIntl } from 'react-intl'

import HeaderLogo from '../components/HeaderLogo'
import PageBg from '../components/PageBg'
import PageHeaderComponents from '../components/PageHeader'

import './css/style.css'

const { Title } = Typography
const { TextArea } = Input

const Invite = (props) => {
  const { history } = props
  const intl = useIntl()
  const validateMessages = {
    required: '',
  }

  const [token, setToken] = useState('') // from Windows
  const [orgCode, setOrgCode] = useState('')
  const [demoEmail, setDemoEmail] = useState('name@felo.com')
  const [loading, setLoading] = useState(false)
  const [tokenLoading, setTokenLoading] = useState(false)

  const submit = (values) => {
    const { email } = values
    console.log(email)
    const emailArr = splitEmail(email)
    console.log('emailArr', emailArr)
    if (!emailArr.length) {
      return
    }
    invite(emailArr)
  }

  const splitEmail = (emails) => {
    if (!emails.length) {
      return []
    }
    const emailArr = emails.split(/[,;\s\n]/)
    let errStr = ''
    let rsp = []
    emailArr.map((item) => {
      if (!item.trim()) {
        return
      }
      if (checkEmail(item)) {
        rsp.push(item)
      } else {
        errStr += `"${item}",`
      }
    })
    if (errStr) {
      errStr = errStr.slice(0, -1)
      message.error(intl.formatMessage({ id: 'email.err' }, { email: errStr }))
      return []
    }
    return rsp
  }

  const checkEmail = (email) => {
    const reg =
      /^([\w-_]+(?:\.[\w-_]+)*)@((?:[a-z0-9]+(?:-[a-zA-Z0-9]+)*)+\.[a-z0-9]{2,10}(\.[a-z]{2,10})*)$/i
    return reg.test(email)
  }

  const resetDemoEmail = (account) => {
    if (!account) {
      return
    }

    const emailStrArr = account.split('@')
    const emialSuffix = emailStrArr[emailStrArr.length - 1]
    setDemoEmail(`name@${emialSuffix}`)
  }

  // 身份验证token 转成 JWT token
  const getToken = (token) => {
    setTokenLoading(true)
    const url = API.GET_TOKEN
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
        token: token,
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.errCode == '0000') {
          props.setGlobalToken(rsp.token)
          const { userInfo } = rsp
          if (userInfo) {
            const { buin, account } = userInfo
            setOrgCode(buin)
            resetDemoEmail(account)
          }
        } else {
          message.error(GetErrMsg(rsp.errCode))
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
      .finally(() => {
        setTokenLoading(false)
      })
  }

  const invite = (emails) => {
    setLoading(true)

    PostEmailInvite({
      accounts: emails,
      lang: LOCAL_LANG[intl.locale],
      corpId: props.corpId || orgCode,
      email: props.email,
      token: props.token,
    })
      .then((rsp) => {
        if (token) {
          history.push({
            pathname: '/invite_result',
            data: { inviteResult: rsp.data },
          })
        } else {
          message.success(intl.formatMessage({ id: 'send.success' }))
          setTimeout(() => {
            history.push('/download')
          }, 1000)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const skip = () => {
    history.push('/download')
  }

  const getUrlToken = () => {
    const { search } = props.location
    const urlQuertParamsStr = search.replace(/^\?/, '')
    const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr)
    if (queryParamsData && queryParamsData.token) {
      const iDentifytoken = decodeURIComponent(queryParamsData.token)
      setToken(iDentifytoken)
    }
  }

  useEffect(() => {
    getUrlToken()
  }, [])

  useEffect(() => {
    if (token) {
      getToken(token)
    }
  }, [token])

  return (
    <>
      <PageBg className={[token ? 'hide' : '']} />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full invite-page ${token ? 'no-margin-top' : ''}`}
      >
        <Col span={COL_SPAN}>
          <section className={`hd-section createTeamHead`} hidden={token}>
            <HeaderLogo />
            <Title level={2}>
              {intl.formatMessage(
                { id: 'join.corp' },
                { name: props.corpName }
              )}
            </Title>
          </section>

          <Title level={5} className={`${token ? 'move-up-60' : ''}`}>
            {intl.formatMessage({ id: 'invite.title' })}
          </Title>

          <Form
            onFinish={submit}
            validateTrigger={'onSubmit'}
            validateMessages={validateMessages}
          >
            <Spin
              spinning={tokenLoading}
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            >
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <TextArea
                  autoFocus
                  size="large"
                  placeholder={`${demoEmail}, ${demoEmail}, ...`}
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  disabled={tokenLoading}
                />
              </Form.Item>
            </Spin>
            <Form.Item className={token ? 'no-margin-bottom' : ''}>
              <Button
                block
                className="mt-20"
                type="primary"
                htmlType="submit"
                size="large"
                loading={loading}
              >
                {token
                  ? intl.formatMessage({ id: 'send' })
                  : intl.formatMessage({ id: 'next' })}
              </Button>
            </Form.Item>
            <Form.Item hidden={token}>
              <div className="content-center">
                {!token && (
                  <Button type="link" onClick={skip}>
                    {intl.formatMessage({ id: 'skip.this.step' })}
                  </Button>
                )}
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  )
}

const stateProps = (state) => {
  return {
    token: state.token,
    email: state.email,
    loginKey: state.loginKey,
    corpName: state.corpName,
    corpId: state.corpId,
  }
}

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: 'setToken',
      value: token,
    })
  },
})

export default connect(stateProps, dispatchProps)(Invite)
